import { Component, Input } from '@angular/core';
@Component({
    selector: 'ins-waving-hand-animation',
    templateUrl: 'waving-hand-animation.component.html',
    styleUrls: ['waving-hand-animation.component.scss'],
})
export class WavingHandAnimationComponent {
    @Input() public animationDuration: string = '3s';
}
